import React from "react";
import { AppDrawer } from "@/components/YhDrawer";
import { useCustomerDiscountModel } from "../customerDiscountModel";
import { Form, Input, Radio } from "antd";
import { useEffect } from "react";


export const AuditDrawer = () => {
    const { auditDrawerVisible: { visible, type }, setAuditDrawerVisible, auditExamined, casherExamined } = useCustomerDiscountModel();
    const [form] = Form.useForm();
    const onCancel = () => {
        setAuditDrawerVisible({ visible: false, type: "" });
    };

    useEffect(() => {
        visible && form.setFieldsValue({ 'isAgre': '0', 'advise': "" })
    }, [visible])

    const onOk = () => {
        form.validateFields().then(val => {
            type === "audit" ? auditExamined(val) : casherExamined(val);
        })
    }

    const formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 },
    };

    return (
        <AppDrawer
            {...{
                title: `${type === "audit" ? "机构" : "财务"}审核意见`,
                visible: visible,
                onOk,
                onCancel,
                showFooter: true
            }}
        >
            <Form
                form={form}
                {...formItemLayout}
            >
                <Form.Item name="isAgre" label="是否同意" rules={[{ required: true, message: "请选择是否同意" }]}>
                    <Radio.Group>
                        <Radio value="0">同意</Radio>
                        <Radio value="1">驳回</Radio>
                    </Radio.Group>
                </Form.Item>
                <Form.Item name="advise" label="审核意见" rules={[{ required: true, message: "请填写审核意见" }]}>
                    <Input.TextArea />
                </Form.Item>
            </Form>
        </AppDrawer>
    )
}
